import { environment } from '@/constants/getEnvironment'
import { BusinessUser } from '@/features/users/types'
import * as Sentry from '@sentry/vue'

export const useSentryEvents = () => {
  const setSentryUser = (user: BusinessUser | null) => {
    if (environment === 'development') return

    if (!user) {
      Sentry.setUser(null)
      return
    }

    Sentry.setUser({
      id: user.id,
      email: user.email,
      name: `${user.first_name} ${user.last_name}`,
    })
  }

  return { setSentryUser }
}
